import axios from 'axios';
import { loginService } from './LoginService';

export const listService = {
  addProductToList,
  getLists,
  getCounts,
  getSpecificList,
  editProduct,
  deleteProduct,
  saveList,
  deleteList,
  searchList,
  updateList,
  deleteLists,
  addBidingTime,
  stopBidingTime,
  getFinalValidation,
  finalizeValidation,
  mergeLists,
  getSublist,
  deleteSublist,
  getSublistDetails,
  directSendList,
  directSendSublist,
  downloadListPdf,
  downloadSublistPdf,
  getManualProcessingSuppliers,
  blockManualProcessingSupplier,
  downloadManualProcessingPdf,
  updateManualProcessingStatus,
  getManualProcessingSupplierDetails,
  moveItemToUnassigned,
  archiveList,
  updateManualProcessingItemStatus
};

function addProductToList(data) {
  const { list_id } = data;

  const url = list_id
    ? `${process.env.REACT_APP_API_URL}/api/necessity_lists/${list_id}/add_product`
    : `${process.env.REACT_APP_API_URL}/api/necessity_lists/start_with_product`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: buildRequestData(data, !!list_id)
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function buildRequestData(
  {
    product_id,
    quantity,
    unit_measurement,
    supplementary_info = '',
    list_description
  },
  isExistingList
) {
  const itemData = {
    product_id,
    quantity,
    unit_measurement,
    supplementary_info
  };

  if (isExistingList) {
    return { necessity_list_item: itemData };
  } else {
    return {
      necessity_list_item: itemData,
      necessity_list: {
        description: list_description
      }
    };
  }
}
function getLists(listView) {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists?list_view=${listView}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function getCounts() {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/counts`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function directSendSublist(listId, sublistId, supplierIds, deliveryMethod = 'email') {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/sublists/${sublistId}/direct_send`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    },
    data: {
      direct_send: {
        supplier_ids: Array.isArray(supplierIds) ? supplierIds : [supplierIds],
        delivery_method: deliveryMethod
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function directSendList(listId, supplierIds, deliveryMethod = 'email') {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/direct_send`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    },
    data: {
      direct_send: {
        supplier_ids: Array.isArray(supplierIds) ? supplierIds : [supplierIds],
        delivery_method: deliveryMethod
      }
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function getSpecificList(listId) {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/admin_view`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function editProduct(listId, productData) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/update_product/${productData.product_id}`;

  const requestOptions = {
    method: 'PATCH',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      necessity_list_item: {
        product_id: productData.product_id,
        quantity: productData.quantity,
        unit_measurement: productData.unit_measurement,
        supplementary_info: productData.supplementary_info || ''
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function deleteProduct(listId, productId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/remove_product/${productId}`;

  const requestOptions = {
    method: 'DELETE',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function saveList(listData) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listData.id}/finalize`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      id: listData.id,
      title: listData.title,
      description: listData.description,
      status: listData.status,
      created_at: listData.created_at,
      updated_at: listData.updated_at
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function deleteList(listId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}`;

  const requestOptions = {
    method: 'DELETE',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }

  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function searchList(title, pageNumber, searchView) {
  const page = pageNumber || 1;
  const baseUrl = `${process.env.REACT_APP_API_URL}/api/necessity_lists/search`;
  const params = new URLSearchParams();

  params.append('page[number]', page);
  if (title) params.append('title', title);
  if (searchView) params.append('list_view', searchView);

  const url = `${baseUrl}?${params.toString()}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function updateList(listId, listData) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}`;

  const requestOptions = {
    method: 'PATCH',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {

      title: listData.title,
      description: listData.description,
      status: listData.status || ''

    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function deleteLists(listsIds) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/bulk_delete`;

  const requestOptions = {
    method: 'DELETE',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      "ids": listsIds
    }

  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function addBidingTime(listId, timeAdded) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/extend_bidding_time`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      necessity_list: {
        "extra_minutes": timeAdded
      }
    }



  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function stopBidingTime(listId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/stop_bidding`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }

  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function getFinalValidation(listId) {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/final_validation_view`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function finalizeValidation(listId, payload) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/final_validation`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: payload
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function mergeLists(listIds, newTitle) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/merge`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      source_list_ids: listIds,
      title: newTitle
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function getSublist(listId) {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/sublists`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
} function getSublistDetails(listId, sublistId) {
  let url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/sublists/${sublistId}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  }
  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function deleteSublist(listId, sublistId, productId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/sublists/${sublistId}/remove_product/${productId}`;

  const requestOptions = {
    method: 'DELETE',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function downloadListPdf(listId, supplierId) {
  const query = supplierId ? `?supplier_id=${supplierId}` : '';
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/download_pdf${query}`;

  const requestOptions = {
    method: 'GET',
    url,
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}

function downloadSublistPdf(listId, sublistId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/sublists/${sublistId}/download_pdf`;

  const requestOptions = {
    method: 'GET',
    url,
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function getManualProcessingSuppliers(listId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/manual_processing_view`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function blockManualProcessingSupplier(listId, supplierId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/manual_processing_suppliers/${supplierId}/block`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function downloadManualProcessingPdf(listId, supplierId) {
  const manualProcessingUrl = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/manual_processing_suppliers/${supplierId}/download_pdf`;
  const fallbackUrl = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/download_pdf?supplier_id=${supplierId}`;
  const requestOptions = {
    method: 'GET',
    url: manualProcessingUrl,
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions).catch((error) => {
    if (error?.response?.status !== 404) {
      throw error;
    }

    return axios({
      ...requestOptions,
      url: fallbackUrl
    });
  });
}
function updateManualProcessingStatus(listId, supplierId, prepared) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/manual_processing_suppliers/${supplierId}/prepared`;

  const requestOptions = {
    method: 'PATCH',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      manual_processing_supplier_list: {
        prepared
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function getManualProcessingSupplierDetails(listId, supplierId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/manual_processing_suppliers/${supplierId}`;

  const requestOptions = {
    method: 'GET',
    url,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function moveItemToUnassigned(itemId) {
  const url = `${process.env.REACT_APP_API_URL}/api/manual_processing_items/${itemId}/move_to_unassigned`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function archiveList(listId) {
  const url = `${process.env.REACT_APP_API_URL}/api/necessity_lists/${listId}/archive`;

  const requestOptions = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
function updateManualProcessingItemStatus(itemId, status) {
  const url = `${process.env.REACT_APP_API_URL}/api/manual_processing_items/${itemId}/status`;

  const requestOptions = {
    method: 'PATCH',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: {
      manual_processing_item: {
        procurement_status:status
      }
    }
  };

  if (loginService.loggedIn()) {
    requestOptions.headers['Authorization'] = loginService.getToken();
  }

  return axios(requestOptions);
}
